import React from 'react'
import { Widget } from "@digital/ui";
import { Col, Collapse, Icon, Row, Steps } from "antd";
import { OrdemCompraDadosGerais } from '@app/api/sas/ordemCompra';
import WidgetDocumentacao from '../WidgetDocumentacao/WidgetDocumentacao';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './custom.css'
interface AbaDocumentacaoProps {
    dadosGerais: OrdemCompraDadosGerais
}

const AbaDocumentacao = ({ dadosGerais }: AbaDocumentacaoProps) => {
    return (
        <PerfectScrollbar className='remove-padding-top'>
            <Widget>
                <Row>
                    <Col >
                        <Collapse
                            className="aba-sumario"
                            bordered={false}
                            defaultActiveKey={'documentacaoContratacao'}
                            expandIcon={() => <Icon type="arrows-right_4" />}>
                            <WidgetDocumentacao ehFornecedor={true} />
                        </Collapse>
                    </Col>
                </Row>
            </Widget>
        </PerfectScrollbar>
    )
}

export default AbaDocumentacao